export const getIsUngatedByForceSeatsPricingParam = () => new URLSearchParams(window.location.search).get('forceSeatsPricing') === 'true';